<template>
  <div class="list">
    <div class="breadcrumb"><a href="/">首页</a>&nbsp;&nbsp;>&nbsp;&nbsp;{{this.columnName}}</div>
    <div class="list_left" v-if="this.$route.params.columnId == '9'">
      <h4>新闻分类</h4>
      <span :class="{'active':currentSort == 1}" @click="torouters(1)">国内要闻</span>
      <span :class="{'active':currentSort == 2}" @click="torouters(2)">省内要闻</span>
      <span :class="{'active':currentSort == 3}" @click="torouters(3)">本地要闻</span>
      <span :class="{'active':currentSort == 4}" @click="torouters(4)">其他要闻</span>
    </div>
    <div class="list_left" v-if="this.$route.params.columnId == '8'">
      <h4>巡视巡查</h4>
      <span :class="{'active':currentSort == 1}" @click="torouterss(1)">上级巡视巡察</span>
      <span :class="{'active':currentSort == 2}" @click="torouterss(2)">本级巡视巡察</span>
			<span :class="{'active':currentSort == 3}" @click="torouterss(3)">下级巡视巡察</span>
    </div>
		<ul class="newslist" :class="this.columnName === '新闻要闻' ? 'newss' : ''" >
      <li v-for="item in ggList" :key="item.news_id" @click="details(item.news_id)">
        <div class="list_right">
					<h3>
						<span class="h3_left">{{item.news_art_title}}</span>
						<span class="h3_right">{{item.news_art_time.substr(0,10)}}</span>
					</h3>
          <div v-html="item.news_art_content"></div>
        </div>
      </li>
		</ul>
    <div class="page" style="float:left;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="paginations.page_index"
        :page-sizes="paginations.page_sizes"
        :page-size="paginations.page_size"
        :layout="paginations.layout"
        :total="paginations.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import "@/assets/css/style.css";
import {imgPath,cityId,permissionsId,keywords,description,metatitle,SiteName,SiteDomain} from "@/api/api"
export default {
  name: "list",
  data() {
    return {
      ggList:[], //数据
      paginations:{
        page_index:1, //当前页
        total:0, //总数
        page_size:4, //一页显示多少
        layout:'total,prev,pager,next'
      },
      allTableData:[],
      imgPath,
      permissionsId,
      currentSort: 0,
      columnName:''
    };
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path != from.path){
        this.path = to.path;
        this.httpPost();//重新加载数据
      }
    }
  },
  metaInfo(){
    return{
      title:this.columnName + "_" + metatitle,
      meta:[
        {name:'keywords',content:keywords},
        {name:"description",content:description},
        {name:"SiteName",content:SiteName},
        {name:"SiteDomain",content:SiteDomain},
        {name:"SiteIDCode",content:"辽ICP备16006427号-2"},
        {name:"ColumnName",content:this.columnName},
        {name:"ColumnDescription",content:this.columnName},
        {name:"ColumnKeywords",content:this.columnName},
        {name:"ColumnType",content:this.columnName}
      ]
    }
  },
  created(id){
    this.httpPost()
  },
  methods: {
    httpPost() {
      const _this = this;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/GetNewsList",
        data:{
          "city_id":cityId,
          "permissions_id":permissionsId,
          "column_id":_this.$route.params.columnId
        },
        success(res){
          if(_this.$route.params.columnId == 9){
            _this.allTableData = res.extend.guoNeiList;
            _this.allTableData = _this.allTableData.concat(res.extend.ShengNeiList).concat(res.extend.benDiList)
            _this.columnName = res.extend.columnName;
          }else{
            _this.allTableData = res.extend.news_list;
            _this.columnName = res.extend.columnName;
          }
          _this.setPaginations();
        }
      })
    },
    setPaginations(){
      const _this = this;
      _this.paginations.total = _this.allTableData.length; //数据的数量
      _this.paginations.page_index = 1; //默认显示第一页
      //显示数据
      _this.ggList = _this.allTableData.filter((item,index) => {
        return index < _this.paginations.page_size;
      })
    },
    handleSizeChange(page_size) {
      const _this = this;
      _this.paginations.page_index = 1; //第一页
      _this.paginations.page_size = page_size; //每页先显示多少数据
      _this.ggList = _this.allTableData.filter((item,index) => {
        return index < page_size
      })
    },
    handleCurrentChange(page){
      // 跳转页数
      //获取当前页
      const _this = this;
      let index = _this.paginations.page_size * (page -1);
      //获取总数
      let allData = _this.paginations.page_size * page;
      
      let tablist=[];
      for(let i = index;i<allData;i++) {
        if (_this.allTableData[i]) {
          tablist.push(_this.allTableData[i])
        }
        _this.ggList = tablist
      }
    },
    torouters(id){
      const _this = this;
      _this.currentSort  =  id;
      id = id == "0" ? null : id;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/SelectNewsByNewsType",
        data:{
          "city_id":cityId,
          "file_type_id":id,
        },
        success(res){
          _this.allTableData = res.extend.news_list;
          _this.setPaginations();
        }
      })
    },
    torouterss(id){
      const _this = this;
      _this.currentSort  =  id;
      id = id == "0" ? null : id;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/SelectXsxcByNewsType",
        data:{
          "city_id":cityId,
          "file_type_id":id,
        },
        success(res){
          _this.allTableData = res.extend.news_list;
          _this.setPaginations();
        }
      })
    },
    details(id){
      let blank = this.$router.resolve({
        path: '/list/details/' + id,
      });
      window.open(blank.href,'_blank')
    }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/list/list.vue